import { typingReducerModel } from "../../models/model";
import { actionTypes } from "../action/action";

const initialState=  {
typingUser:{},
msgType:0,
typingList:{}
}

export const typingReducerState = (state: typingReducerModel = initialState, action: any) => {
    switch (action.type) {
    case actionTypes.TYPING_STATUS:
        return {
          ...state,
          msgType:action.payload.msgType,
          typingList: action.payload.typingList,
          typingUser: action.payload.typingUser
          };
          default:
            return state;
        }
}